exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MuiFormControl-root{width:100%}.MuiInputBase-root.Mui-disabled{color:rgba(0,0,0,0.7) !important;background-color:rgba(0,0,0,0.1) !important}\n", ""]);

